module.exports = __webpack_public_path__ + "img/29_BF7_the_sky_has_fallen.10b2c3ee.jpg";